<template>
  <div class="auth-redirect">
    Redirecting to RITM...
  </div>
</template>

<script>
import { setCookie } from "@/utils";

export default {
  created() {
    const token = this.$route.params.token.replace(/!/g, ".");
    setCookie("token", token, { expires: 24 * 3600 });
    this.$store.commit("CLEAR_USER_DATA");
    this.$store.commit("SET_USER_DATA", { user: {}, token });
    this.$router.push({ path: "/app/desktop" });
  }
};
</script>

<style lang="scss">
.auth-redirect {
  font-size: 14px;
}
</style>
